import { render, staticRenderFns } from "./Classification.html?vue&type=template&id=a285107c&external"
import script from "./Classification.js?vue&type=script&lang=js&external"
export * from "./Classification.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports